import { jsx as _jsx } from "react/jsx-runtime";
import { ChipStyled } from './QuantityChip.styled';
const QuantityChip = (props) => {
    return _jsx(ChipStyled, { ...props });
};
export { QuantityChip };
